import { Outlet } from 'react-router-dom';

export default function Insights() {
  return <Outlet />;
}


